import { render, staticRenderFns } from "./PayForm.vue?vue&type=template&id=4793e95e&"
import script from "./PayForm.vue?vue&type=script&lang=js&"
export * from "./PayForm.vue?vue&type=script&lang=js&"
import style0 from "./PayForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PayForm.vue"
export default component.exports